<template>
  <div class="strategy-card">
    <div class="strategy-card-top">
      <div class="card-icon">
        <!-- <component :is="icon" /> -->
        <img :src="icon" alt="">
      </div>
      <div class="card-content">
        <div class="card-title">{{  title }}</div>
        <div class="card-desc">{{ description }}</div>
      </div>
      <div>
        <el-badge v-if="customLength > 0" :value="customLength" :max="5" class="btn-open-drawer appointment"></el-badge>
      </div>
    </div>
    <div class="strategy-card-line"></div>
    <div class="card-action" v-if="!isSwitch">
      <div class="action-button" @click="$emit('click')">
        {{ actionText }} <el-icon>
          <ArrowRight />
        </el-icon>
      </div>
    </div>
    <div class="card-action" v-if="isSwitch">
      <div class="action-button">
        <el-switch v-model="switchValue" @change="handleSwitchChange" :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRight } from '@element-plus/icons-vue'

import { ref, watch } from 'vue'
const $str = window.$str;

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: '设置和设备运行策略，包括工作日策略和休息日策略'
  },
  actionText: {
    type: String,
    default: '查看'
  },
  icon: {
    type: [String, Object],
    required: true
  },
  isSwitch: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  customLength: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click', 'update:modelValue', 'change'])

// 开关状态
const switchValue = ref(props.modelValue)

// 监听外部值变化
watch(() => props.modelValue, (newValue) => {
  switchValue.value = newValue
})

// 处理开关状态变化
function handleSwitchChange(value) {
  emit('update:modelValue', value)
  emit('click', value)
}
</script>

<style lang="scss" scoped>
.strategy-card {
  display: flex;
  flex-flow: column;
  background: rgba(44, 53, 72, 1);
  border-radius: 8px;
  padding: 16px 20px;
  // margin-bottom: 12px;
  height: 130px;

  .strategy-card-top {
    display: flex;
    flex-flow: row;

    .card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      color: currentColor;
      font-size: 24px;
      margin-right: 10px;
    }

    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .card-title {
        font-weight: 600;
        font-size: 15px;
        color: #FFFFFF;
        margin-bottom: 6px;
        
      }

      .card-desc {
        font-size: 12px;
        color: #97A0B7;
        line-height: 1.4;
      }
    }
  }

  .strategy-card-line {
    height: 1px;
    width: 114%;
    background: rgba(72, 81, 110, 0.6);
    margin: 5px -20px;
  }

  .card-action {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .action-button {
      display: flex;
      align-items: center;
      color: #576BFF;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #7C8CFF;
      }

      .el-icon {
        margin-left: 4px;
      }
    }
  }
}
</style>